// This import loads the firebase namespace along with all its type information.
import ProcessedSocialMediaAccount from './processed-social-media-account-model'

export async function load_processedSocialMediaAccounts(): Promise<
  ProcessedSocialMediaAccount[]
> {
  throw 'Not implemented'
}

export async function delete_processedSocialMediaAccount(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_processedSocialMediaAccount(): Promise<ProcessedSocialMediaAccount> {
  throw 'Not implemented'
}
